
$(document).ready(function() {
    $('.js-menu-btn').click(function(evt) {
        var target_category = $(this).data('target-menu');

        if(!$('.js-menu-wrapper[data-menu=' + target_category + ']').hasClass('active-menu')) {
            $('.js-menu-wrapper').removeClass('active-menu');
            $('.js-menu-wrapper[data-menu=' + target_category + ']').addClass('active-menu');
        } else {
            $('.js-menu-wrapper[data-menu=' + target_category + ']').removeClass('active-menu');
        }
        
        return false;
    });
});